/**
 * Project : workspace
 * File    : BrandListScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.inventory.brand.list

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.inventory.brand.viewmodel.BrandViewModel
import com.parmartechnologies.core.navigation.NavigationParam
import component.empty.EmptyData
import component.loader.AppLoader
import component.navigation.TopNavBar
import locale.localization
import navigation.AppNavigator
import navigation.route.inventory.InventoryNavRoute
import presentation.screens.business.inventory.brand.component.BrandRow
import theme.ThemeColor

/**
 * Represents the brand list screen class.
 */

class BrandListScreen{
    @Composable
    fun Content() {
        val businessViewModel = BusinessViewModel()
        val myBusiness = businessViewModel.myBusiness.collectAsState()
        val viewModel = BrandViewModel(myBusiness.value)
        
        val allBrand = viewModel.allBrand.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.loadAllBrand()
        }
        Column(
            modifier = Modifier.fillMaxSize()
                .background(ThemeColor.shared().defaultBakground)
        ) {
            TopNavBar(
                title = localization().brandMenu.brandTitle,
                NavigationParam(),
                onBackPress = {
                    AppNavigator.shared().goBack()
                },
                onClickAdd = {
                    AppNavigator.shared().navigate(InventoryNavRoute.Brand.CREATE)
                })
            AppLoader(viewModel)
            if (allBrand.value.isNotEmpty()) {
                LazyVerticalGrid(
                    columns = GridCells.Adaptive(minSize = 400.dp),
                    modifier = Modifier.fillMaxSize().padding(bottom = 60.dp)
                ) {
                    items(count = allBrand.value.count()) { index ->
                        BrandRow(brand = allBrand.value[index], onClick = {
                            AppNavigator.shared().navigate(
                                InventoryNavRoute.Brand.UPDATE,
                                NavigationParam(
                                    business = myBusiness.value,
                                    brand = it
                                )
                            )
                        })
                    }
                }
            } else {
                EmptyData(viewModel = viewModel) {
                    viewModel.loadAllBrand()
                }
            }
        }
    }
}